import { useContext, useState } from "react";
import { Box, CircularProgress, Grid, IconButton } from "@mui/material";
import { ArrowBack, ArrowForward, WhatsApp } from "@mui/icons-material";
import CustomText from "../components/CustomText";
import CustomButton from "../components/CustomButton";
import ImageLoader from "../components/ImageLoader";
import { ScreenContext } from "../context/ScreenContext";
import { trackEvent } from "../utils/analytics";
import { openWhatsApp } from "../utils/openWhatsApp";
import { useLocation } from "react-router-dom";

const CarouselCard = ({ cards = [], colorIcon, loadingPackages }) => {
  const location = useLocation();
  const { isMobile, dimensionWidth } = useContext(ScreenContext);
  const Dimension = dimensionWidth < 1220;

  const [startIndex, setStartIndex] = useState(0);
  const itemsPerPage = Dimension ? 1 : 3;
  const total = cards.length || 0;

  const handleNext = () => {
    const next = startIndex + itemsPerPage;

    if (next < total) {
      setStartIndex(next);
    }
  };

  const handlePrev = () => {
    const prev = startIndex - itemsPerPage;

    if (prev >= 0) {
      setStartIndex(prev);
    }
  };

  const getVisibleCards = () => {
    return cards.slice(startIndex, startIndex + itemsPerPage);
  };

  const handlePromotionWhatsApp = (promotion) => {
    trackEvent("whatsapp_promotion", {
      page_path: location.pathname,
      page_url: window.location.href,
      section: "promociones",
      promotion: promotion.title,
      value: 1,
    });

    openWhatsApp(
      "5514772163",
      `Hola MoviCare 👋.
Estoy interesado en la promoción:
*${promotion.title}*
¿Podrían brindarme más información y ayudarme a agendarla?
¡Gracias!`,
      true,
    );
  };

  if (loadingPackages) {
    return (
      <Box sx={design.LoadingState}>
        <CircularProgress />
        Cargando promociones...
      </Box>
    );
  }

  const color = colorIcon ? colorIcon : "#FFF";
  return (
    <>
      <Box style={design.Align}>
        {!isMobile && (
          <IconButton onClick={handlePrev} disabled={startIndex === 0}>
            <ArrowBack fontSize="large" color={color} />
          </IconButton>
        )}
        {getVisibleCards().map((doc, index) => (
          <Box key={doc.id || index}>
            <ImageLoader
              src={doc.img || doc.imagen}
              alt={doc.title || "Promoción"}
              width={350}
              height={185}
            />
            <Grid container sx={design.GridCard}>
              <CustomText variant="subtitle1" color="#5c5c5c" sx={design.Mas}>
                ¡Con esta colaboración, realiza tus estudios y rayos X desde
                casa!
              </CustomText>
              <CustomButton
                type="button"
                variant="contained"
                backgroundColor="#356c2d"
                colorTexto="#FFF"
                width="100%"
                height={45}
                borderRadius={30}
                align
                style={design.Boton}
                onClick={() => handlePromotionWhatsApp(doc)}
              >
                <WhatsApp sx={design.Whats} />
                Cotizar por WhatsApp
              </CustomButton>
              <Box sx={design.BoxText}>
                <CustomText
                  variant="subtitle1"
                  color="#0D5E9E"
                  sx={design.Text}
                >
                  Servicio subrogado por:
                </CustomText>
                <Box
                  component="img"
                  src="https://movicaremx.com/IMG/BACKGROUNDS/MOVICARE_3000Color.png"
                  alt="MoviCare"
                  sx={design.Movi}
                />
              </Box>
            </Grid>
          </Box>
        ))}
        {!isMobile && (
          <IconButton
            onClick={handleNext}
            disabled={startIndex + itemsPerPage >= total}
          >
            <ArrowForward color={color} fontSize="large" />
          </IconButton>
        )}
      </Box>
      {isMobile && (
        <Grid container pt={3}>
          <IconButton onClick={handlePrev} disabled={startIndex === 0}>
            <ArrowBack color={color} fontSize="large" />
          </IconButton>
          <IconButton
            onClick={handleNext}
            disabled={startIndex + itemsPerPage >= total}
          >
            <ArrowForward color={color} fontSize="large" />
          </IconButton>
        </Grid>
      )}
    </>
  );
};

export default CarouselCard;
const design = {
  Align: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    marginTop: "2%",
  },
  Mas: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 15,
    lineHeight: "normal",
  },
  LoadingState: {
    marginTop: 5,
    marginBottom: 2,
    color: "#666",
    fontFamily: "Plus Jakarta Sans",
    fontSize: 16,
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "2rem",
  },
  GridCard: {
    backgroundColor: "#EAEAEA",
    width: "350px",
    pt: 8,
    mt: -5,
    borderRadius: "0 0 20px 20px",
    px: 3,
    pb: 3,
    justifyContent: "center",
  },
  Boton: {
    marginTop: 20,
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 700,
    fontSize: 12,
    textTransform: "none",
    boxShadow: "none",
  },
  whats: { mr: 1, fontSize: 24 },
  BoxText: {
    mt: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    flexWrap: "wrap",
  },
  Text: {
    fontFamily: "Plus Jakarta Sans",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1,
  },
  Movi: {
    width: 100,
    height: "auto",
    objectFit: "contain",
  },
};
